export class CenterData {
  centerCode: string;
  oracleAccount: string;
  customerCode: string;
  paymentTerms: string;
  paymentMethod: string;
  zoneId: number;
  sendIse: boolean;
  locked: boolean;
}
